import script from "./pDefaultDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./pDefaultDialog.vue?vue&type=script&setup=true&lang=js"

import "./pDefaultDialog.vue?vue&type=style&index=0&id=64fdab6b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fdab6b"]])

export default __exports__